import { caseStudies } from "../sample_assets/case_studies";
import { HeaderNavComponent } from "./header-nav-compontent"

export const CaseStudyPage = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const caseStudyId = urlParams.get("caseStudyId");
    if (!caseStudyId) {
        window.location.href = "/learning-center";
        return null;
    }
    const caseStudy = caseStudies.find((cs) => cs.id === caseStudyId);

    return (
        <div className="case-study-page min-h-screen">
            <HeaderNavComponent variant="product" />
            <main className="case-study-content flex p-12">
                {caseStudy && caseStudy.fullHtml}
            </main>
        </div>
    )

}
